import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createTradeDealApi, storeTradeDealApi } from './tradeDealSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import TradeDealForm from './TradeDealForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function TradeDealCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialValuess = {
        from_item_id: 0,
        to_item_id: 0,
    };

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.

        dispatch(storeTradeDealApi({ navigate, values }));
    };

    return (
        <TradeDealForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValuess}
            formSubmit={formSubmit}
        />
    );
}

export default TradeDealCreate;
